

export const API_BASE_URL = "https://www.girabat.com/api";
export const API_BASE_URL_V2 = "https://www.girabat.com";

 
// export const API_BASE_URL = "https://localhost:7248/api";
// export const API_BASE_URL_V2 = "https://localhost:7248";
